import TeamSection from '../components/TeamSection';

const Team = () => {
  return <TeamSection />;
};

export default Team;
